export default {
    install(Vue, store) {
        Vue.prototype.$t = (trans_key, replace) => {

            const translations_module = store.state.translations;

            if (typeof translations_module[trans_key] !== 'undefined') {
                let string = translations_module[trans_key];

                if (replace) {
                    for (let i = 0; i < replace.length; i += 1) {
                        string = string.replace(`:${replace[i][0]}`, replace[i][1]);
                    }
                }

                return string;
            }
        }
        return '';
    },
};